import React, { SVGProps } from 'react'
const SvgBudgetRequestLabel = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path fill="#fff" d="M0 0h24v24H0z" />
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M12.675 5.625a7.199 7.199 0 1 1-6.23 10.853l-.04-.082a.5.5 0 0 1 .22-.604l5.606-3.255-.057-6.407a.5.5 0 0 1 .5-.505Zm.504 1.024.054 6.17-.007.09a.5.5 0 0 1-.242.348l-5.403 3.135.057.085a6.199 6.199 0 1 0 5.644-9.82l-.103-.008Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.691 5.289a7.565 7.565 0 0 0-6.546 11.403l6.518-3.84.028-7.563Z"
      clipRule="evenodd"
    />
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M12.693 4.789a.5.5 0 0 1 .498.501l-.028 7.563a.5.5 0 0 1-.246.43l-6.518 3.84a.5.5 0 0 1-.684-.178 8.064 8.064 0 0 1 6.978-12.156Zm-.528 7.776.025-6.76-.036.002a7.05 7.05 0 0 0-5.332 3.074l-.155.239a7.062 7.062 0 0 0-.354 6.826l.027.052 5.825-3.433Z"
    />
    <path
      fill={props.fill || 'var(--color-cta)'}
      stroke="#fff"
      strokeWidth={0.8}
      d="M5.038 11.63h3.614l-.56.715-.012.014-.01.015-.048.076-.01.015-.009.016a.9.9 0 0 0 1.506.974l1.7-2.17.011-.016.01-.016.053-.082.01-.016.01-.018a.9.9 0 0 0-.095-.963l-1.7-2.17-.01-.013-.013-.013-.062-.066-.012-.013-.013-.012a.9.9 0 0 0-1.153-.035l-.014.01-.013.013-.066.062-.013.012-.012.013a.9.9 0 0 0-.035 1.153l.56.714H5.043l-.139-.003c-.524-.029-.866-.224-1.099-.592C3.552 8.835 3.4 8.187 3.4 7.2a.9.9 0 1 0-1.8 0c0 1.343.264 2.45.844 3.229.596.799 1.483 1.2 2.594 1.2Z"
    />
  </svg>
)
export default SvgBudgetRequestLabel
